import { PrintSectionLayout } from "../../layout";

export const HostMemoOfPrintComposition = () => {
	return (
		<PrintSectionLayout titleChildren={<p className="text-xs">その他の留意事項</p>}>
			<div className="h-24 rounded-sm border border-solid border-zinc-200" />
		</PrintSectionLayout>
	);
};
